import {
  SearchSuggestionType,
  LinkTrackingData,
} from '../../../../../AnalyticsContext/LinkTracking';
import { Practice } from '../../../../icons/outlined/Practice';
import {
  SuggestionIcon,
  SuggestionPrimary,
  SuggestionSecondary,
} from '../SuggestionStyles/SuggestionStyles.styles';
import { SuggestionTemplate } from '../SuggestionTemplate/SuggestionTemplate';

export const PracticeSuggestion = ({
  name,
  specialties,
  suburb,
  state,
  trackingData,
}: {
  name: string;
  specialties: string[];
  suburb: string;
  state: string;
  trackingData: LinkTrackingData;
}) => (
  <SuggestionTemplate
    trackingData={{ ...trackingData, searchSuggestionType: SearchSuggestionType.PRACTICE }}
    visual={
      <SuggestionIcon>
        <Practice />
      </SuggestionIcon>
    }
    primary={<SuggestionPrimary>{name}</SuggestionPrimary>}
    secondary={
      <SuggestionSecondary>
        {specialties.join(', ')}
        {(specialties.length && ' - ') || ''}
        {suburb} {state}
      </SuggestionSecondary>
    }
  />
);
